import { useEffect, useState } from "react";

import Image from "next/legacy/image";
import { useTimer } from "react-timer-hook";

import { blurDataURL } from "../../../utils/constants/images";
import { formatValue } from "../../../utils/helpers/formatValues";
import { convertToDateWithMonthFirst } from "../../../utils/helpers/dateAndTime";
import Badge from "../../common/Badge";
import VoteNowButton from "../../common/buttons/VoteNowButton";
import { PLAYER_POLL_URL } from "../../../utils/constants/websiteUrls";

const PollListCard = ({ poll }) => {
  // console.log(poll);
  const pollEndTime = new Date(poll.end_time);

  const [formattedDateTime, setFormattedDateTime] = useState("");

  useEffect(() => {
    setFormattedDateTime(convertToDateWithMonthFirst(poll.published_on));
  }, [poll.published_on]);

  const {
    seconds,
    minutes,
    hours,
    days,
    isRunning,
    start,
    pause,
    resume,
    restart,
  } = useTimer({
    pollEndTime,
    autoStart: true,
    onExpire: () => console.warn("onExpire called"),
  });

  return (
    <>
      <article className="flex flex-col bg-gray-900 rounded-md">
        <div className="relative object-cover w-full h-52 bg-gray-500 rounded-tr-md rounded-tl-md">
          <Image
            src={poll.thumbnail}
            alt="Poll Thumbnail"
            layout="fill"
            objectFit="cover"
            placeholder="blur"
            blurDataURL={blurDataURL}
            className="rounded-tr-md rounded-tl-md"
          />
          <div className="absolute inset-0">
            {String(days) === "0" || String(days) === "00" ? (
              <Badge categoryName={`${hours}:${minutes}:${seconds}`} />
            ) : (
              <Badge categoryName={`${days}:${hours}:${minutes}:${seconds}`} />
            )}
          </div>
        </div>

        <div className="flex flex-col flex-1 p-6">
          <div className="flex flex-wrap justify-between pt-3 space-x-2 text-xs text-gray-400">
            <span>{formattedDateTime}</span>
            <span>{`${formatValue(poll.total_votes)} votes`}</span>
          </div>

          <div>
            <h3 className="text-lg font-semibold leading-snug">{poll.title}</h3>

            <p className="text-gray-100 text-sm">{poll.caption}</p>
          </div>

          {poll.type === "player_poll" ? (
            <VoteNowButton link={`${PLAYER_POLL_URL}/${poll.slug}`} />
          ) : (
            <VoteNowButton link={`${TEXT_POLL_URL}/${poll.slug}`} />
          )}
        </div>
      </article>
    </>
  );
};

export default PollListCard;
